import {
  Avatar,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PreOrderIcon, PurpleClose } from 'Images';
import { useNavigate } from 'react-router-dom';

interface IExistingOrderDialog {
  open: boolean;
  handleClose: () => void;
  renewPrescription?: string[];
  date: string;
}
export const ExistingOrderDialog = (props: IExistingOrderDialog) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Equipment
  ).existingOrderDialog;
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  return (
    <Dialog
      PaperProps={{
        sx: {
          overflowY: 'visible',
          backgroundColor: 'primary.shade_100',
          width: 'calc(100% - 32px)',
        },
      }}
      maxWidth='md'
      fullWidth
      open={props.open}
      onClose={props.handleClose}
      sx={{ mt: '10vh' }}
      aria-labelledby={'existing-order-dialog-title'}
      aria-describedby={'existing-order-dialog-content'}
    >
      <IconButton
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: isDesktop ? '8px' : '13px',
          top: isDesktop ? '12px' : '13px',
        }}
      >
        <Avatar
          alt={generalDictionary.closeWindow}
          src={PurpleClose}
          sx={{
            width: isDesktop ? '42px' : '34px',
            height: isDesktop ? '42px' : '34px',
          }}
        />
      </IconButton>
      <DialogContent
        sx={{
          padding: isDesktop ? '64px' : '48px 20px',
        }}
        id={'existing-order-dialog-content'}
        tabIndex={0}
      >
        <Stack alignItems='center' mt={'0'}>
          <Avatar
            alt=''
            src={PreOrderIcon}
            sx={
              isDesktop
                ? {
                    width: '160px',
                    height: '120px',
                  }
                : { width: '110px', height: '90px' }
            }
          />
          <Typography
            textAlign='center'
            paragraph
            margin={'30px 0 20px 0'}
            component='h2'
            variant='h3'
            id={'existing-order-dialog-title'}
          >
            {dictionary.title}
          </Typography>

          <Typography
            variant='body3'
            textAlign={isDesktop ? undefined : 'center'}
          >
            {dictionary.info1} {props.date}
          </Typography>
          <Typography
            variant='body3'
            textAlign={isDesktop ? undefined : 'center'}
          >
            {dictionary.info2}
          </Typography>

          <Stack
            sx={{
              flexDirection: 'row',
              mt: '50px',
              justifyContent: 'center',
              gap: isDesktop ? 6 : 2,
            }}
          >
            <NextPrevButton
              callback={() => navigate('/Equipment')}
              isBlue
              text={dictionary.back}
              style={
                isDesktop
                  ? undefined
                  : {
                      button: { width: '110px', height: '36px' },
                      text: { fontSize: '16px', fontWeight: '600' },
                    }
              }
            />
            <NextPrevButton
              callback={props.handleClose}
              isNext
              text={dictionary.submit}
              style={
                isDesktop
                  ? undefined
                  : {
                      button: { height: '36px' },
                      text: { fontSize: '16px', fontWeight: '600' },
                    }
              }
            />
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
